import axios from "axios";
import { Lead_Service_URL } from "../Url";
import HashMap from "hashmap";
import { clearLogoutData } from "../logout/action";

export const getLeadDocListActions = {
  LEAD_DOC_LIST_SUCCESS: "LEAD_DOC_LIST_SUCCESS",
  LEAD_DOC_LIST_ERROR: "LEAD_DOC_LIST_ERROR",
};

export const getAllLeadDocActions = {
  GET_ALL_LEAD_DOC_LIST_SUCCESS: "GET_ALL_LEAD_DOC_LIST_SUCCESS",
  GET_ALL_LEAD_DOC_LIST_ERROR: "GET_ALL_LEAD_DOC_LIST_ERROR",
};
export const proceedLeadDocActions = {
  PROCEED_LEAD_DOC_LIST_SUCCESS: "PROCEED_LEAD_DOC_LIST_SUCCESS",
  PROCEED_LEAD_DOC_LIST_ERROR: "PROCEED_LEAD_DOC_LIST_ERROR",
};
// ALL Documents List
export function getLeadDocumentMastersList(props) {
  const { access_token, leadId } = props;
  let values = {};
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Lead_Service_URL}/get/Lead/DocumentMasters?leadId=${leadId}`,
      //   data: values,
      headers: {
        Authorization: "Bearer " + access_token,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getLeadDocListSuccess(values));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getLeadDocListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getLeadDocListError(err));
          return err.response;
        }
      });
}

export function getLeadDocListSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getLeadDocListActions.LEAD_DOC_LIST_SUCCESS,
      payload: props,
    });
  };
}

export function getLeadDocListError(error) {
  return {
    type: getLeadDocListActions.LEAD_DOC_LIST_ERROR,
    payload: error,
  };
}

// Uploaded Document List
export function getAllLeadDoc(props) {
  const { access_token, leadId } = props;
  let values = {};
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Lead_Service_URL}/getAll/LeadDoc?leadId=${leadId}`,
      //   data: values,
      headers: {
        Authorization: "Bearer " + access_token,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getAllLeadDocSuccess(values));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getAllLeadDocError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getAllLeadDocError(err));
          return err.response;
        }
      });
}

export function getAllLeadDocSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getAllLeadDocActions.GET_ALL_LEAD_DOC_LIST_SUCCESS,
      payload: props,
    });
  };
}

export function getAllLeadDocError(error) {
  return {
    type: getAllLeadDocActions.GET_ALL_LEAD_DOC_LIST_ERROR,
    payload: error,
  };
}

// Create Lead Document
export function proceedLeadDoc(props) {
  const { access_token, leadId } = props;
  let values = {};
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Lead_Service_URL}/proceed/LeadDocSection?leadId=${leadId}`,
      //   data: values,
      headers: {
        Authorization: "Bearer " + access_token,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(proceedLeadDocSuccess(values));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(proceedLeadDocError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(proceedLeadDocError(err));
          return err.response;
        }
      });
}

export function proceedLeadDocSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: proceedLeadDocActions.PROCEED_LEAD_DOC_LIST_SUCCESS,
      payload: props,
    });
  };
}

export function proceedLeadDocError(error) {
  return {
    type: proceedLeadDocActions.PROCEED_LEAD_DOC_LIST_ERROR,
    payload: error,
  };
}
